/**
 * 优惠券相关store
 */
import { getCouponCommonEnum } from '@/api/coupon-system/common'
const state = {
	// 优惠券
	couponEnum: null
}
const mutations = {
	SET_COUPON: (state, couponEnum) => {
		state.couponEnum = couponEnum
	}
}
const actions = {
	// 获取优惠券枚举
	getCouponCommonEnum({ commit, state }, payload) {
		return new Promise(async (resolve, reject) => {
			if (state.couponEnum) {
				resolve(state.couponEnum)
			} else {
				try {
					const { data } = await getCouponCommonEnum(payload)
					commit('SET_COUPON', data)
					resolve(data)
				} catch (error) {
					reject(error)
				}
			}
		})
	}
}
export default {
  namespaced: true,
  actions,
  state,
  mutations
}
